import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {ProductBuyMobileCart} from 'modules/product-card/components/ProductBuyMobileCart';
import {ProductBuyReserveButton} from 'modules/product-card/components/ProductBuyReserveButton';
import {selectProductData} from 'modules/product-card/selectors';
import {FC} from 'react';

export const ProductBuyMobile: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {canBuy, canReserve} = productData || {};

    if (canBuy) {
        return <ProductBuyMobileCart />;
    }

    if (canReserve) {
        return <ProductBuyReserveButton />;
    }

    return null;
};
